import script from "./logicEditor.vue?vue&type=script&lang=js"
export * from "./logicEditor.vue?vue&type=script&lang=js"

import "./logicEditor.vue?vue&type=style&index=0&id=72e0b706&lang=scss"

const __exports__ = script;

export default __exports__